import react from "react";
import Jump from 'react-reveal/Jump';
import { Parallax } from "react-parallax";
import {particlesOptions} from "./particles";

//Components
import MyNavbar from "./components/my-navbar/mynavbar.jsx";
import Mycarousal from "./components/my-carousal/mycarousal.jsx";
import TitleMessage from './components/title-message/title-message.jsx'
import About from './pages/about/about.jsx'
import Container from "react-bootstrap/Container";
import Skills from "./pages/skills/skills";
import Experience from "./pages/experience/experience.jsx"
import Timeline from "./components/projectTimeline/project.jsx"
import ContactForm from "./pages/contact/contact.jsx"
import FooterPanel from "./components/footer/footer.jsx"


import Particles from "react-particles-js";


import './App.css';

const App = () => {
  return (

    <div className="App" style={{position: "relative"}}>
      <MyNavbar />
      { <Particles
        className="particles particles-box"
        params={particlesOptions}
      />}

      <Mycarousal/>
      <TitleMessage />

      <div>
        <Parallax blur={{ min: -30, max: 30 }}
          bgImage={require("./assets/img/parallex/slide1.jpg")}
          bgImageAlt=""
          strength={-200}
        >

          <Container className="container-box rounded">
            <Jump duration = {1000}>
              <About />
            </Jump>
            
          </Container>

        </Parallax>    
      </div>

      
        <div>
          <Container className="container-box rounded">
            <Jump duration = {1000}>
              <Skills/>
            </Jump>
            
          </Container> 
        </div>

      <div>
          <Container className="container-box rounded">
            <Jump duration = {1000}>
               <Experience/>
            </Jump>
            
          </Container> 
      </div>
     <div>
          <Container className="container-box rounded">
            <Jump duration = {1000}>
              <Timeline/>
            </Jump>
            
          </Container> 
      </div>

      <Container className="container-box rounded">
        <Jump duration={500}>
          <hr />
          <ContactForm />
        </Jump>
      </Container>

      <FooterPanel/>
      


    </div>
  );
}

export default App;
